<template>
  <ValidationObserver ref="userLoginForm">
    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div class="container">
        <div class="row justify-content-center">
          <!-- <div class="col-md-12 go-to-home-page">
            <router-link to="/"
              ><img src="/media/backgrounds/left-arrow.png" />back to home
              page</router-link
            >
          </div>
          <div class="col-md-6">
            <div class="welcome-login">
              <img src="/media/backgrounds/welcome-bg-blue.png" />
            </div>
          </div> -->
          <div class="col-md-6">
            <div class="form-wraapper-inner">
              <h1>Verification Code</h1>
              <p>
                Bitte geben Sie den Anmelde-Code ein, den Sie per E-Mail
                erhalten haben.
                <b>{{ this.$route.query.email }}</b>
              </p>

              <div v-if="formErr" role="alert" class="alert alert-danger">
                <div class="alert-text">{{ formErr }}</div>
              </div>

              <ValidationProvider
                name="verification code"
                rules="required|numeric"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Verification code is required.',
                }"
              >
                <v-text-field
                  autocomplete="new-password"
                  v-model="form.code"
                  :error-messages="errors[0]"
                  label="Code eingeben"
                  outlined
                ></v-text-field>
              </ValidationProvider>

              <v-btn
                type="submit"
                ref="kt_form_submit_btn"
                class="submit-btn-fill-color"
                :disabled="isDisabled"
              >
                {{ btnText }}
              </v-btn>
              <div class="signin">
                <p><router-link to="/">Zurück zum Login.</router-link>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import { FRONTEND_LOGIN } from "@/core/services/store/auth.module";
export default {
  name: "ForgotPassword",
  data() {
    return {
      btnText: "Abschicken",
      btnDisable: false,
      form: {
        code: "",
      },
      formErr: null,
    };
  },
  created() {
    if (!this.$route.query.email) {
      this.$router.push({
        name: "index",
      });
    }
  },
  methods: {
    onSubmit() {
      this.formErr = null;
      this.$refs.userLoginForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.btnText = "Wird abgeschickt...";
          setTimeout(() => {
            axios
              .post("verify-code", {
                email: this.$route.query.email,
                code: this.form.code,
              })
              .then((response) => {
                var responseJson = response.data;
                if (responseJson.status == "success") {
                  this.$router.push({
                    name: "reset-password",
                    query: { email: this.$route.query.email },
                  });
                } else {
                  this.btnDisable = false;
                  this.btnText = "Abschicken";
                  this.formErr = responseJson.message;
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.btnDisable = false;
                this.btnText = "Abschicken";
                this.formErr = err;
              });
          }, 2000);
        }
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>